import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const AdminSalesRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'payments',
        component: wrapRuntimeImport(() => import('./screens/payments.vue')),
        meta: { admin: true },
        redirect: '/admin/sales/payments/payment-methods',
        children: [
            {
                path: 'payment-methods',
                component: wrapRuntimeImport(() => import('./screens/payments/payment-methods-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'stripe-account',
                component: wrapRuntimeImport(() => import('./screens/payments/stripe-account.vue')),
                meta: { admin: true }
            },
            {
                path: 'card-terminals',
                component: wrapRuntimeImport(() => import('./screens/payments/card-terminals.vue')),
                meta: { admin: true }
            }
        ]
    },
    {
        path: 'payments/stripe-oauth',
        component: wrapRuntimeImport(() => import('./screens/payments/stripe-oauth.vue')),
        meta: { admin: true }
    },
    {
        path: 'quickbooks',
        component: wrapRuntimeImport(() => import('./screens/quickbooks.vue')),
        meta: { admin: true }
    },
    {
        path: 'fulfillment',
        component: wrapRuntimeImport(() => import('./screens/fulfillment.vue')),
        meta: { admin: true, ...makePermissionMeta('sales', 'fulfillmentEdit') }
    },
    {
        path: 'categories',
        component: wrapRuntimeImport(() => import('./screens/categories.vue')),
        meta: { admin: true }
    },
    {
        path: 'layouts',
        component: wrapRuntimeImport(() => import('./screens/layouts.vue')),
        meta: { admin: true },
        redirect: '/admin/sales/layouts/manage',
        children: [
            {
                path: 'manage',
                component: wrapRuntimeImport(() => import('./screens/layouts/manage-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'assignments',
                component: wrapRuntimeImport(() => import('./screens/layouts/assignments-tab.vue')),
                meta: { admin: true }
            }
        ]
    },
    {
        path: 'layouts/manage/:id',
        component: wrapRuntimeImport(() => import('./screens/layout-editor.vue')),
        meta: { admin: true }
    },
    {
        path: 'booking',
        component: wrapRuntimeImport(() => import('./screens/booking.vue')),
        meta: { admin: true }
    },
    {
        path: 'booking/:activityId',
        component: wrapRuntimeImport(() => import('./screens/booking-activities/activity-detail.vue')),
        meta: { admin: true },
        redirect: to => `/admin/sales/booking/${to.params.activityId}/general`,
        children: [
            {
                path: 'general',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/general-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'scheduling',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/scheduling-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'policies',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/policies-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'availability',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/schedules-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'slot-durations',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/slot-durations-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'cancellation-rules',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/cancellation-rules-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'resources',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/resource-types-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'blocked-times',
                component: wrapRuntimeImport(() => import('./screens/booking-activities/blocked-times-tab.vue')),
                meta: { admin: true }
            }
        ]
    },
    {
        path: 'financial-accounts',
        component: wrapRuntimeImport(() => import('./screens/financial-accounts.vue')),
        meta: { admin: true }
    },
    {
        path: 'predefined-discounts',
        component: wrapRuntimeImport(() => import('./screens/predefined-discounts.vue')),
        meta: { admin: true }
    },
    {
        path: 'credit-pools',
        component: wrapRuntimeImport(() => import('./screens/credit-pools.vue')),
        meta: { admin: true }
    },
    {
        path: 'modifier-sets',
        component: wrapRuntimeImport(() => import('./screens/modifier-sets.vue')),
        meta: { admin: true }
    },
    {
        path: 'settings',
        component: wrapRuntimeImport(() => import('./screens/settings.vue')),
        meta: { admin: true }
    },
    {
        path: 'taxes',
        component: wrapRuntimeImport(() => import('./screens/taxes.vue')),
        meta: { admin: true },
        redirect: '/admin/sales/taxes/automatic',
        children: [
            {
                path: 'automatic',
                component: wrapRuntimeImport(() => import('./screens/taxes/automatic-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'types',
                component: wrapRuntimeImport(() => import('./screens/taxes/types-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'groups',
                component: wrapRuntimeImport(() => import('./screens/taxes/groups-tab.vue')),
                meta: { admin: true }
            }
        ]
    },
    {
        path: 'automations',
        component: wrapRuntimeImport(() => import('./screens/automations.vue')),
        meta: { admin: true }
    },
    {
        path: 'automations/:id/runs',
        component: wrapRuntimeImport(() => import('./screens/automations/runs.vue')),
        meta: { admin: true }
    }
];
